import { useEffect, useState } from "react";

// Simple Mode: hides advanced/optional controls (sub-checks on Inspection Wizard,
// chargeback flag, material entries, etc.) for new techs who just need Clock In →
// Add Photo → Complete Room. Stored in localStorage per-device so preference sticks.
// Default: ON for workers (opt-out), OFF for admins (opt-in via Settings).

const STORAGE_KEY = "fieldradar_simple_mode";

export function isSimpleModeOn() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === "1") return true;
    if (v === "0") return false;
  } catch { /* ignore */ }
  return true; // default ON — new guys get the calmer UI out of the box
}

export function setSimpleMode(on) {
  try {
    localStorage.setItem(STORAGE_KEY, on ? "1" : "0");
    window.dispatchEvent(new CustomEvent("simple-mode-changed", { detail: { on } }));
  } catch { /* ignore */ }
}

export function useSimpleMode() {
  const [on, setOn] = useState(isSimpleModeOn());
  useEffect(() => {
    const h = (e) => setOn(!!e.detail?.on);
    const s = () => setOn(isSimpleModeOn());
    window.addEventListener("simple-mode-changed", h);
    window.addEventListener("storage", s);
    return () => {
      window.removeEventListener("simple-mode-changed", h);
      window.removeEventListener("storage", s);
    };
  }, []);
  const toggle = () => setSimpleMode(!on);
  return { simpleMode: on, toggleSimpleMode: toggle, setSimpleMode };
}
